
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class IstekSikayetBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "IstekSikayetSave";
    super(baseUrl);
  }


  saveIstekSikayetBasvuruSave(request: IstekSikayetSaveRequest){
    
    return this.post("", request, true);
   
  }

}
export default new IstekSikayetBasvuruAPI();


class IstekSikayetSaveRequest {
    basvuruTuruId?: number;
    sicilKodu?: number;
    adi: string;
    soyadi: string;
    tckimlikNo: number;
    gsmKodu: string;
    cepTelefonu: string;
    alanKodu?: string;
    sabitTelefon?: string;
    ePostaAdresi: string;
    ikametgahAdresi?: string;
    belediyeSiniriIcindeMi?: string;
    basvuruNedeniKodu: number;
    konuBasligiKodu: number;
    mahalleKodu: number;
    caddeSokakKodu: number;
    kapiNo?: number;
    altKapiNo?: string;
    daireNo?: number;
    altDaireNo?: string;
    basvuruMetni: string;
    kimlikBilgilerimiGizle?: string;
    smsBildirimiIstiyorum?: string;
    captchaToken?: string;

    constructor(
        adi: string,
        soyadi: string,
        tckimlikNo: number,
        gsmKodu: string,
        cepTelefonu: string,
        ePostaAdresi: string,
        basvuruNedeniKodu: number,
        konuBasligiKodu: number,
        mahalleKodu: number,
        caddeSokakKodu: number,
        basvuruMetni: string,
        basvuruTuruId?: number,
        sicilKodu?: number,
        alanKodu?: string,
        sabitTelefon?: string,
        ikametgahAdresi?: string,
        belediyeSiniriIcindeMi?: string,
        kapiNo?: number,
        altKapiNo?: string,
        daireNo?: number,
        altDaireNo?: string,
        kimlikBilgilerimiGizle?: string,
        smsBildirimiIstiyorum?: string,
        captchaToken?: string
    ) {
        this.sicilKodu = sicilKodu;
        this.adi = adi;
        this.soyadi = soyadi;
        this.tckimlikNo = tckimlikNo;
        this.gsmKodu = gsmKodu;
        this.cepTelefonu = cepTelefonu;
        this.alanKodu = alanKodu;
        this.sabitTelefon = sabitTelefon;
        this.ePostaAdresi = ePostaAdresi;
        this.ikametgahAdresi = ikametgahAdresi;
        this.belediyeSiniriIcindeMi = belediyeSiniriIcindeMi;
        this.basvuruNedeniKodu = basvuruNedeniKodu;
        this.konuBasligiKodu = konuBasligiKodu;
        this.mahalleKodu = mahalleKodu;
        this.caddeSokakKodu = caddeSokakKodu;
        this.kapiNo = kapiNo;
        this.altKapiNo = altKapiNo;
        this.daireNo = daireNo;
        this.altDaireNo = altDaireNo;
        this.basvuruTuruId = basvuruTuruId;
        this.basvuruMetni = basvuruMetni;
        this.kimlikBilgilerimiGizle = kimlikBilgilerimiGizle;
        this.smsBildirimiIstiyorum = smsBildirimiIstiyorum;
        this.captchaToken = captchaToken;
    }
}
export  {IstekSikayetSaveRequest};
